<template>
  <v-card class="elevation-12">
    <v-toolbar color="primary" dark>
      Отчёты
    </v-toolbar>

    <v-card-text>
      <v-row class="px-2">
        <v-col cols="12" md="4" lg="2" offset-lg="3">
          <v-menu
              v-model="filterStartMenu"
              transition="scale-transition"
              offset-y
              :nudge-right="40"
              max-width="290px"
              min-width="290px"
              :close-on-content-click="false"
          >
            <template v-slot:activator="{on}">
              <v-text-field
                  label="Начало пероида"
                  v-model="startFilterDisplayValue"
                  readonly
                  v-on="on"
                  flat
              />
            </template>
            <v-date-picker
                v-model="filters.start"
                @change="onFilterStartChanged"
                no-title
                scrollable
                locale="ru"
                first-day-of-week="1"
            />
          </v-menu>
        </v-col>
        <v-col cols="12" md="4" lg="2">
          <v-menu
              v-model="filterEndMenu"
              transition="scale-transition"
              offset-y
              :nudge-right="40"
              max-width="290px"
              min-width="290px"
              :close-on-content-click="false"
          >
            <template v-slot:activator="{on}">
              <v-text-field
                  label="Конец пероида"
                  v-model="endFilterDisplayValue"
                  readonly
                  v-on="on"
                  flat
              />
            </template>
            <v-date-picker
                v-model="filters.end"
                @change="onFilterEndChanged"
                no-title
                scrollable
                locale="ru"
                first-day-of-week="1"
            />
          </v-menu>
        </v-col>
        <v-col cols="12" md="4" lg="2">
          <v-btn @click="onRefreshClicked" large class="primary">Обновить</v-btn>
          <v-btn @click="onDownloadClicked" large class="primary ml-2">Скачать</v-btn>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-text>
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
          <tr>
            <th rowspan="3" style="width: 50px;" class="text-center">№ <br/>п/п</th>
            <th rowspan="3" style="width: 66px;">№ <br/>реестра</th>
            <th rowspan="3">Дата реестра</th>
            <th rowspan="3" style="width: 94px;">
              Кол-во <br/>
              документов <br/>
              в реестре <br/>
              (передано <br/>
              ТТЭ для <br/>
              доставки)
            </th>
            <th rowspan="3">
              Вид <br/>
              уведомле <br/>
              ния
            </th>
            <th rowspan="3">Подразделение (заметка)</th>
            <th rowspan="3">
              Распечатано <br/>
              почтой
            </th>
            <th colspan="9">
              Статус уведомления
            </th>
          </tr>
          <tr>
            <th rowspan="2">Доставлено <br/>почтой</th>
            <th rowspan="2">Не <br/> доставлено <br/> почтой <br/>(10+11+12+<br/>13+14+15)</th>
            <th colspan="6">в т.ч.</th>
            <th rowspan="2">Итого <br/>(8+9)</th>
          </tr>
          <tr>
            <th>
              (1)<br/>
              Адресат умер
            </th>
            <th>
              (2)<br/>
              Адресат по указанному адресу не проживает
            </th>
            <th>
              (3)<br/>
              Указан неполный <br/>адрес(нет номера дома, <br/>не указаны название улицы <br/>и т.д.)
            </th>
            <th>
              (4)<br/>
              Адресат (с семьей) временно выехал
            </th>
            <th>
              (5)<br/>
              Адресат от получения отказался
            </th>
            <th>
              (6)<br/>
              Адресат за получением не явился
            </th>
          </tr>
          <tr>
            <th v-for="n in 16" :key="n">{{ n }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(record, index) in records" :key="record.registry.id">
            <td class="text-center">{{ index + 1 }}</td>
            <td class="text-center">{{ record.registry.id }}</td>
            <td class="text-center">{{ record.registry.createdOn.format('DD.MM.YYYY HH:mm:ss') }}</td>
            <td class="text-center">{{ record.registry.mailsCount }}</td>
            <td class="text-center">01</td>
            <td class="text-left">{{ record.registry.note }}</td>
            <td class="text-center">{{ record.printedCount }}</td>
            <td class="text-center">{{ record.deliveredCount }}</td>
            <td class="text-center">{{ record.notDelivered }}</td>
            <td class="text-center">{{ record.receiverDeadCount }}</td>
            <td class="text-center">{{ record.receiverNotLivesThereCount }}</td>
            <td class="text-center">{{ record.incompleteAddressCount }}</td>
            <td class="text-center">{{ record.notAtHomeCount }}</td>
            <td class="text-center">{{ record.receiverRefuseCount }}</td>
            <td class="text-center">{{ record.didntAppearOnNoticeCount }}</td>
            <td class="text-center">{{ record.total }}</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td class="text-center"><b>ИТОГО</b></td>
            <td class="text-center"><b>{{ totals.totalImportMailsCount }}</b></td>
            <td></td>
            <td></td>
            <td class="text-center"><b>{{ totals.totalPrintedCount }}</b></td>
            <td class="text-center"><b>{{ totals.totalDeliveredCount }}</b></td>
            <td class="text-center"><b>{{ totals.totalNotDelivered }}</b></td>
            <td class="text-center"><b>{{ totals.totalReceiverDeadCount }}</b></td>
            <td class="text-center"><b>{{ totals.totalReceiverNotLivesThereCount }}</b></td>
            <td class="text-center"><b>{{ totals.totalIncompleteAddressCount }}</b></td>
            <td class="text-center"><b>{{ totals.totalNotAtHomeCount }}</b></td>
            <td class="text-center"><b>{{ totals.totalReceiverRefuseCount }}</b></td>
            <td class="text-center"><b>{{ totals.totalDidntAppearOnNoticeCount }}</b></td>
            <td class="text-center"><b>{{ totals.totalTotals }}</b></td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import Moment from "moment";
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import RegistryService from "@/services/registry.service";
import _ from 'underscore'
import Mappers from '@/mappers'

export default {
  name: "ReportView",
  data() {
    return {
      filters: {
        start: null,
        end: null
      },
      startFilterDisplayValue: null,
      endFilterDisplayValue: null,
      filterStartMenu: false,
      filterEndMenu: false,

      records: []
    }
  },
  computed: {
    totals() {
      const totals = {
        totalImportMailsCount: 0,
        totalPrintedCount: 0,
        totalDeliveredCount: 0,
        totalNotDelivered: 0,
        totalReceiverDeadCount: 0,
        totalReceiverNotLivesThereCount: 0,
        totalIncompleteAddressCount: 0,
        totalNotAtHomeCount: 0,
        totalReceiverRefuseCount: 0,
        totalDidntAppearOnNoticeCount: 0,
        totalTotals: 0
      }

      _.each(this.records, r => {
        totals.totalImportMailsCount += r.registry.mailsCount
        totals.totalPrintedCount += r.printedCount
        totals.totalDeliveredCount += r.deliveredCount
        totals.totalNotDelivered += r.notDelivered
        totals.totalReceiverDeadCount += r.receiverDeadCount
        totals.totalReceiverNotLivesThereCount += r.receiverNotLivesThereCount
        totals.totalIncompleteAddressCount += r.incompleteAddressCount
        totals.totalNotAtHomeCount += r.notAtHomeCount
        totals.totalReceiverRefuseCount += r.receiverRefuseCount
        totals.totalDidntAppearOnNoticeCount += r.didntAppearOnNoticeCount
        totals.totalTotals += r.total
      })

      return totals
    }
  },
  methods: {
    refresh() {
      this.$store.dispatch(LAYOUT_LOADING_START)
      RegistryService.getRegistriesReport({
        start: Moment(this.filters.start, 'YYYY-MM-DD'),
        end: Moment(this.filters.end, 'YYYY-MM-DD')
      })
          .then(response => {
            this.records = _.map(response.data, r => {
              return {
                registry: Mappers.mapRegistry(r.Registry),
                printedCount: r.PrintedCount,
                deliveredCount: r.DeliveredCount,
                notDelivered: r.NotDelivered,
                receiverDeadCount: r.ReceiverDeadCount,
                receiverNotLivesThereCount: r.ReceiverNotLivesThereCount,
                incompleteAddressCount: r.IncompleteAddressCount,
                receiverRefuseCount: r.ReceiverRefuseCount,
                notAtHomeCount: r.NotAtHomeCount,
                didntAppearOnNoticeCount: r.DidntAppearOnNoticeCount,
                total: r.Total
              }
            })
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    onRefreshClicked() {
      this.refresh()
    },
    onDownloadClicked() {
      this.$store.dispatch(LAYOUT_LOADING_START)
      RegistryService.downloadRegistriesReport({
        start: Moment(this.filters.start, 'YYYY-MM-DD'),
        end: Moment(this.filters.end, 'YYYY-MM-DD')
      })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    onFilterStartChanged() {
      if (this.filters.start) {
        this.startFilterDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
      }

      this.filterStartMenu = false
    },
    onFilterEndChanged() {
      if (this.filters.end) {
        this.endFilterDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')
      }

      this.filterEndMenu = false
    }
  },
  created() {
    this.filters.start = Moment().format('YYYY-MM-DD')
    this.filters.end = Moment().format('YYYY-MM-DD')

    this.startFilterDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
    this.endFilterDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')

    this.refresh()
  }
}
</script>

<style scoped>
thead tr th {
  border: 1px solid black !important;
  border-right-width: 0 !important;
  text-align: center !important;
  padding: 2px !important;
  border-top-width: 0 !important;
}

thead tr:first-child th {
  border-top: 1px solid black !important;
}

thead tr:not(:nth-child(3)) th:last-child {
  border-right: 1px solid black !important;
}

tr td {
  border: 1px solid #deaf3b !important;
  border-right-width: 0 !important;
  border-top-width: 0 !important;
}

tr td:last-child {
  border-right: 1px solid #deaf3b !important;
  padding: 2px !important;
}
</style>